
import {
    backend_url,
    uninterceptedAxiosInstance,
    qs,
  } from "../common/commonVariables";
export const getOrganisationData = async (organisationID = "") => {
    const query = qs.stringify(
      {
        populate: ["profileImage", "allowed_modules"],
      },
      {
        encodeValuesOnly: true,
      }
    );
    try {
      const response = await uninterceptedAxiosInstance.get(
        backend_url + `organisations/${organisationID}?${query}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }
      );
  
      let the_response = response.data.data;
  
      return the_response;
    } catch (err) {
      if (err.response) {
      } else if (err.request) {
      } else {
      }
  
      return null;
    }
  };

  export const updateCompanyProfile = async (
    id,
    currency,
    country,
    timezone,
    profileImage
  ) => {
    try {
      let params = {
        currency,
        country,
        timezone,
        profileImage,
      };
      if (!currency) {
        delete params.currency;
      }
      if (!country) {
        delete params.country;
      }
      if (!timezone) {
        delete params.timezone;
      }

  
      const response = await uninterceptedAxiosInstance.put(
        backend_url + `organisations/${id}`,
        { data: params },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }
      );
      let the_response = response;
  
      return the_response;
    } catch (err) {
      if (err.response) {
      } else if (err.request) {
      } else {
      }
  
      return {
        status: err?.response?.status,
      };
    }
  };